var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingSubPageTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("お受け取り可能店舗")]},proxy:true},{key:"content",fn:function(){return [_c('PickupStoreList')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }